import { WelcomeUploadComponent } from 'app/welcome/upload/upload.component';
import { Component } from '@angular/core';

import { UILensService } from 'app/ui/lens/lens.service';
import { UserSettingsService } from 'app/user/user-settings.service';

@Component({
  selector: 'welcome-guide',
  templateUrl: 'guide.component.html',
  styleUrls: ['guide.component.scss']
})
export class WelcomeGuideComponent {

  constructor(private _uiLensService: UILensService, private _userSettings: UserSettingsService) { }

  next(): void {
    this._uiLensService.open(WelcomeUploadComponent, 'upload');
  }

  skip(): void {
    this._userSettings.welcomeTraining = true;
    this._uiLensService.close();
  }
}
